import { DISCIPLINARY_RECORDS_UNIVERSITIES } from "@/constants";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["userDetails"]),
    approvedStatuses() {
      return ["Complete", "Submitted", "Pending Approval", "Not Accepted"];
    },
  },
  methods: {
    buildStringDateRange(from, to) {
      let formattedFrom = this.formatDate(from);
      let formattedTo = this.formatDate(to);
      return formattedFrom + " - " + formattedTo;
    },
    formatDate(date) {
      const extractYear = date.substring(0, 4);
      const extractMonth = date.substring(5, 7);
      const extractDay = date.substring(8, 10);

      const newDate = new Date(extractYear, extractMonth - 1, extractDay);
      const dtf = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
      });
      const [
        { value: mo },
        ,
        { value: da },
        ,
        { value: ye },
      ] = dtf.formatToParts(newDate);
      return `${mo} ${da}, ${ye}`;
    },
    async formioSubmissionExists(formPath, applicationId) {
      return await fetch(
        process.env.VUE_APP_FORMIO_URL +
          "/" +
          formPath +
          "/exists?data.application_id=" +
          applicationId,
        {
          headers: {
            "Content-type": "application/json",
            Accept: "application/json",
          },
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("No submission found.");
          } else {
            return response.json();
          }
        })
        .then((response) => {
          this.submission_id = response._id;
          return response._id;
        })
        .catch(() => {
          return false;
        });
    },
    async submitApproval(student) {
      const formioUrl = process.env.VUE_APP_FORMIO_URL + "/advisorapproval";
      let dateRange = "";

      if (student.start_date && student.end_date) {
        dateRange = student.formatDate
          ? ` (${student.start_date} - ${student.end_date})`
          : ` (${this.buildStringDateRange(
              student.start_date,
              student.end_date
            )})`;
      }

      let body = {
        data: {
          application_id: student.approval_application,
          program: {
            value: student.session_id,
            label: student.program_name,
          },
          institution: {
            value: student.university_ope8_id,
            label: student.university_name,
          },
          advisorname: this.userDetails.name,
          campusOfficialEmail: "",
          comments: "",
          submit: true,
          studentname: student.name,
          programname: student.program_name + dateRange,
          institutionname: student.university_name,
          advisoremail: this.userDetails.email,
          programType:
            student.program_type === "Internship" ? "internship" : "abroad",
        },
      };

      let disciplinaryEmail = this.getDisciplinaryEmail(
        student.university_name
      );
      if (disciplinaryEmail) {
        body.data.certifytype = "approvedNoDisciplinaryRecord";
        body.data.campusOfficialEmail = disciplinaryEmail;
      } else {
        body.data.certifytype = "approved";
      }

      //check if submission exists to avoid duplication
      let submissionId = await this.formioSubmissionExists(
        "advisorapproval",
        student.approval_application
      );

      let url = formioUrl;
      let method = "post";
      if (submissionId) {
        method = "put";
        url = formioUrl + "/submission/" + submissionId;
      }
      let response = await fetch(url, {
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          "x-jwt-token": this.$store.state.advisor.token,
        },
        method: method,
        body: JSON.stringify(body),
        mode: "cors",
      });

      return Boolean(response.status == 200 || response.status == 201);
    },
    async setApprovedFlag(applicationId) {
      let url =
        process.env.VUE_APP_ENROLLMENT_URL +
        "/api/progress/approval/" +
        applicationId;
      let response = await fetch(url, {
        headers: {
          "Content-type": "application/json",
          "x-jwt-token": this.$store.state.advisor.token,
        },
        method: "post",
      });

      return {
        success: Boolean(response.status == 200),
        applicationId: applicationId,
      };
    },
    getDisciplinaryEmail(school) {
      const schoolObj = DISCIPLINARY_RECORDS_UNIVERSITIES.find(
        (item) => item.name === school
      );
      return schoolObj !== undefined ? schoolObj.email : "";
    },
  }
};
